export * from './createServiceOwnerRequestDto';
export * from './serviceMappingRequestDto';
export * from './serviceOwnerMapping';
export * from './serviceOwnerMappingGenericResponseDto';
export * from './serviceOwnerTbl';
export * from './serviceOwnerTblGenericListResponseDto';
export * from './serviceOwnerTblGenericResponseDto';
export * from './serviceOwnerUpdate';
export * from './serviceType';
